module.exports = __webpack_public_path__ + "static/media/header-logo.d75be881.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/header-logo.svg
// module id = 211
// module chunks = 2